import styled from "styled-components";

const Select = styled.select`
    border: 1px solid ${(p) => p.theme.secondary};
    border-radius: 6px;
    padding: 0em 0em;
    font-family: ${(p) => p.theme.font};
    font-weight: 500;
    color: ${(p) => p.theme.textLight};
    background: ${(p) => p.theme.secondary};
    height: 3em;

    :hover {
        background: ${(p) => p.theme.secondaryHover};
        cursor: pointer;
    }

    option {
        border-radius: 6px;
        color: black;
        background: white;
        left: 2em;
        top: 2em;
    }
`;

export default Select;